module.exports = __webpack_public_path__ + "report.dcfd53a2bd220bf721d8d259a387fdde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/report.svg
// module id = 143
// module chunks = 0